import React from 'react';
import moment from 'moment';

export default class CustomTimeFieldTransformer {
    transform(value) {
        if (!value) {
            return null;
        }

        // Apply custom date format, for example 'DD.MM.YYYY'
        const formattedTime = moment(value).format('HH:mm');

        return <span>{formattedTime}</span>;
    }
}
